<template>
  <div class="login-wrapper border border-light">
    <img src="../assets/logo_hr.png" alt="DZS" />
    <!-- <form class="form-signin" @submit.prevent="login"> -->
    <form class="form-signin" @submit.prevent="onSubmit">
      <h2 class="form-signin-heading">Prijava u sustav</h2>
      <label for="inputUserName" class="sr-only">Korisničko ime</label>
      <input
        v-model="username"
        type="text"
        id="inputUserName"
        class="form-control"
        placeholder="Korisničko ime"
        required
        autofocus
      />
      <label for="inputPassword" class="sr-only">Lozinka</label>
      <input
        v-model="password"
        type="password"
        id="inputPassword"
        class="form-control"
        placeholder="Lozinka"
        required
      />
      <div class="alert alert-danger" v-if="error">{{ errorMessage }}</div>
      <button
        class="btn btn-lg btn-primary btn-block btn-login-submit"
        type="submit"
      >
        Prijavi se
      </button>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import { router } from "../router";
// import { router } from "@/_helpers";
import { authenticationService } from "@/_services";

export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      loading: false,
      returnUrl: "",
      error: "",
      //error: false,
      errorMessage: "",
    };
  },
  // updated() {
  //   this.checkCurrentLogin();
  // },
  created() {
    this.checkCurrentLogin();
    // redirect to home if already logged in
    //  if (authenticationService.currentUserValue) {
    //   return router.push("/");
    //  }

    // get return url from route parameters or default to '/'
    //this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    onSubmit() {
      this.submitted = true;

      this.loading = true;
      authenticationService.login(this.username, this.password).then(
        (user) => router.push('/processes'),
        (error) => {
          this.error = error;
          this.errorMessage = error;
          this.loading = false;
        }
      );
    },

    async login() {
      await axios
        .post("/auth/login", {
          userName: this.userName,
          password: this.password,
        })
        .then((request) => {
          if (request.data.Success) {
            if (!request.data.Token) {
              this.errorMessage = request.data.ErrorMessage;
              this.error = true;
              delete localStorage.token;
              delete localStorage.user;
              return;
            }
            this.error = false;
            localStorage.token = request.data.Token;
            localStorage.userName = request.data.UserName;
            localStorage.role = request.data.Role;
            this.$router.replace("/processes");
          } else {
            this.errorMessage = request.data.ErrorMessage;
            this.error = true;
            delete localStorage.token;
            delete localStorage.user;
          }
        });
    },
    checkCurrentLogin() {
      if (localStorage.currentUser) {
        this.$router.replace("/documents");
      }
    },
    async authenticate() {
      await axios
        .post("/auth/authenticate", {
          userName: this.userName,
          password: this.password,
        })
        .then((request) => {
          const data = text && JSON.parse(text);
          if (response.ok) {
            if ([401, 403].indexOf(response.status) !== -1) {
              // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
              authenticationService.logout();
              location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
          }

          return data;
        });
    },
  },
};
</script>

<style lang="css">
.login-wrapper {
  background: #fff;
  width: 70%;
  margin: 12% auto;
  text-align: center;
}

.form-signin {
  max-width: 330px;
  padding: 10% 15px;
  margin: 0 auto;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
  margin-bottom: 10px;
  font-size: 1.4rem;
  text-align: center;
}
.form-signin .checkbox {
  font-weight: normal;
}
.form-signin .form-control {
  width: 100%;
  position: relative;
  height: auto;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px;
  font-size: 16px;
  border: 1px solid #4ac2d6;
  line-height: 2rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0.5rem;
}
.form-signin .form-control:focus {
  z-index: 2;
}

.btn-login-submit {
  display: block;
  font-size: 16px;
  line-height: 2rem;
  margin: auto;
  border: 1px solid #17384f;
  padding: 0.5rem 1rem;
  background: #17384f;
  color: #fff;
}

.alert-danger {
  background: #fafafa;
  padding: 1rem;
  margin-bottom: 5px;
  text-align: center;
  color: #e4575c;
  font-weight: 600;
  border: 1px solid rgba(228, 87, 92, 0.5);
  text-transform: uppercase;
  font-size: 12px;
}
</style>
